import { render, staticRenderFns, recyclableRender, components } from "./tn-button.vue?vue&type=template&id=d2dc7f56&scoped=true&"
var renderjs
import script from "./tn-button.vue?vue&type=script&lang=js&"
export * from "./tn-button.vue?vue&type=script&lang=js&"
import style0 from "./tn-button.vue?vue&type=style&index=0&id=d2dc7f56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../软件/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2dc7f56",
  null,
  false,
  components,
  renderjs
)

export default component.exports